import uuid from 'uuid';

export const addPublication = publication => ({
  type: 'ADD_PUBLICATION',
  publication,
});

export const addPublicationFirestore = (database, publication = {}) => {

  return () => {
    return database
    .collection('publications')
    .doc(publication.shortVenue + uuid())
    .set(publication)
    .then(

    )
    .then(() => {
      console.log('Added publication successfully');
    }, (error) => {
      console.error('Add publication Error', error);
    });
  };
};

export const removePublication = ({ id } = {}) => ({
  type: 'REMOVE_PUBLICATION',
  id,
});

export const editPublication = (id, updates) => ({
  type: 'EDIT_PUBLICATION',
  id,
  updates,
});

export const setPublications = publications => ({
  type: 'SET_PUBLICATIONS',
  publications,
});

export const fethPublicationsFirestore = database => (dispatch) => {
  const publications = [];
  return database
    .collection('publications')
    .get()
    .then(
      (publicationsStore) => {
        publicationsStore.forEach((publication) => {
          publications.push({
            id: publication.id,
            ...publication.data(),
          });
        });
      },
    )
    .then(() => { // Set publications in redux
      dispatch(setPublications(publications));
    });
};

// export const fethPublicationsFirestore = () => (dispatch) => {
//   const publications = [
//     {
//       id: 'healthcom2014',
//       title: 'A New Architecture for Secure Storage and Sharing of Health Records in the Cloud using Federated Identity Attributes.',
//       year: '2014',
//       venue: '2014 ieee 16th International Conference on e-Health Networking, Applications and Services (HealthCom) (pp. 194–199)',
//       shortVenue: 'HealthCom 2014',
//       translatedTitle: '',
//       createdAt: '',
//       authors: 'Lucas de Melo silva, Roberto Araújo, Felipe Leite da Silva, Eduardo Cerqueira',
//       doi: 'https://doi.org/10.1109/HealthCom.2014.7001840',
//     },
//     {
//       id: 'sbsc2014',
//       title: 'Caixas de Interesses: Um Novo Mecanismo Para a Colaboração Através de Nuvem de Armazenamento de Dados.',
//       translatedTitle: 'Interest Boxes: A New Mechanism for Collaboration Through Cloud Data Storage',
//       year: '2014',
//       venue: 'XI Brazilian Symposium on Collaborative Systems',
//       shortVenue: 'SBSC 2014',
//       createdAt: '',
//       authors: 'Felipe Leite da Silva, Roberto Araújo, Lucas de Melo silva, Nelson Sampaio',
//       doi: '',
//     },
//     {
//       id: 'sbseg2013',
//       title: 'Integrando o Openstack Keystone Com Uma Federação de Identidades.',
//       translatedTitle: 'Integrating OpenStack Keystone with Federated Identity',
//       year: '2014',
//       venue: 'Brazilian Symposium on Information Security and Computer Systems (pp. 102–110)',
//       shortVenue: 'SBSEG 2013',
//       createdAt: '',
//       authors: 'Lucas de Melo silva, Carlos Eduardo Silva, Felipe Leite da Silva, Roberto Araújo',
//       doi: '',
//     },
//   ];
//   // return database
//   //   .collection('publications')
//   //   .get()
//   //   .then(
//   //     (publicationsStore) => {
//   //       publicationsStore.forEach((publication) => {
//   //         publications.push({
//   //           id: publication.id,
//   //           ...publication.data(),
//   //         });
//   //       });
//   //     },
//   //   )
//   //   .then(() => {
//   //     dispatch(setPublications(publications));
//   //   });
//   dispatch(setPublications(publications));
//   return publications;
// };
